import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';

import {TranslateService} from '@ngx-translate/core';
import {ContactService} from '../../shared/services/contact.service';
import {UtilsService} from '../../shared/services/utils.service';

import { getName, getNames } from '../../shared/thirdparty/countries/countries'

import { NewsService } from '../../shared/services/news.service';
import { LanguageService } from '../../shared/services/language.service';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;
declare var grecaptcha:any;

@Component({
    selector: 'app-white-papers',
    templateUrl: './white-papers.component.html',
    styleUrls: ['./white-papers.component.scss']
})
export class WhitePapersComponent implements OnInit {

    @Input() isRd = false

    public langSub: any
    public activeTag = null
    public slides: any = []
    public featuredWhitePaperId = 0
    public page = 0
    public limit = 9
    public itemsPerPage = 9
    public listWhitePapers = []
    public tags = []
    public nbPosts = 0
    public tagLimit = false
    public toContact = null
    public where;
    public name;
    public company;
    public mail;
    public tel;
    public country;
    public message;
    public interest;
    public problem;
    public modalMessage = "";
    public allCountries = []
    public showGratitude = false

    public whitePaperUrl = null;

    public iframeShow:any = false;
    public sendDisabled:boolean=false;

    public captchaDisplay = true;

    public isBrowser = isBrowser()

    public currentLang = null

    public MISSING_PARAMETER_MESSAGE = this.translate.instant("Tout les champs n'ont pas été correctement remplis");
    public BAD_CAPTCHA_MESSAGE = this.translate.instant("Veuillez re-valider le captcha");
    public GENERAL_ERROR = this.translate.instant("Une erreur est survenue, veuillez réessayer plus tard");
    public SUCCESSFUL = this.translate.instant("Votre message a été envoyé. Nous y répondrons dans les plus brefs délais.")

    public featuredWhitePaper = [
        {
            id: 0,
            img: "assets/Livre_Blanc_Suez_FR",
            title: this.translate.instant("Témoignage Suez - Déploiement de la formation VR à l’international"),
            createdDate: "December 14, 2021",
            shortDesc: this.translate.instant("Le challenge du groupe Suez ? Atteindre l’objectif zéro accident grave et mortel d’ici 2030. Pour ce faire, Suez a fait appel à Immersive Factory qui a développé des modules de formation visant à renforcer la culture santé & sécurité dans les Business Units du groupe. Après une période de «test & learn» et quelques autres initiatives locales, Suez a décidé de déployer les solutions d’Immersive Factory à l’international. Implémentant, de ce fait, la Réalité Virtuelle (VR) dans les programmes de formations de presque tous les pays. Outre la valeur ajoutée et la facilité de déploiement des solutions d’Immersive Factory, les retours terrain ont surtout été très positifs. Découvrez, au travers de ce livre blanc, comment Immersive Factory a collaboré avec Suez pour renforcer sa culture santé & sécurité : l’histoire du groupe, le challenge visé, la solution apportée, les indicateurs de succès, etc .."),
            link: "temoignage-suez-fr.pdf",
            linkEN: "testimonial-suez-en.pdf",
            slides: [
                {
                    src: "assets/people/Bea_Detoure.png",
                    name: "Béatrice DEVIN",
                    job: this.translate.instant("Directrice marketing chez Immersive Factory")
                }
            ]
        }
    ];

    public posts = [
        {
            tag: {
                id: "9",
                "title": this.translate.instant("Clients")
            },
            createdDate: this.translate.instant("December 14, 2021"),
            title: this.translate.instant("Témoignage Suez - Déploiement de la formation VR à l’international"),
            link: "temoignage-suez-fr.pdf",
            linkEN: "testimonial-suez-en.pdf",
            img: "assets/Livre_Blanc_Suez_FR",
            shortDesc: this.translate.instant("Le challenge du groupe Suez ? Atteindre l’objectif zéro accident grave et mortel d’ici 2030. Pour ce faire, Suez a fait appel à Immersive Factory qui a développé des modules de formation visant à renforcer la culture santé & sécurité dans les Business Units du groupe.")
        },
        {
            tag: {
                id: "3",
                "title": this.translate.instant("Innovation")
            },
            createdDate: this.translate.instant("April 12, 2021"),
            title: this.translate.instant("Les atouts de l’immersive learning dans un contexte de télétravail"),
            link: "Les-atouts-immersive-learning-contexte-teletravail.pdf",
            img: "assets/Livre_Blanc_RH",
            shortDesc: this.translate.instant("La crise de la COVID-19 a impacté les entreprises de manière significative et reste une source  d’incertitudes. Salariés, responsables HSE et managers opérationnels s’interrogent sur les moyens de minimiser les complications dues aux contraintes sanitaires et au développement du télétravail. Placé au cœur de cette problématique, la formation et la communication deviennent un levier essentiel pour impliquer les collaborateurs. Animé désormais par un double enjeu, l’apprentissage doit non seulement former chacun aux nouveaux gestes et habitudes de travail, mais également garantir la continuité des formations tout en s’assurant qu’elles ne seront pas à l’origine de risques supplémentaires. Pour atteindre ces objectifs, l’apprentissage immersif (ou immersive learning) peut servir d’inspiration. A l’heure où les interactions relationnelles à distance peuvent s’essouffler, les outils interactifs d’animations de réunions en ligne, de simulation 3D, de gamification ou encore de réalité virtuelle, par exemple, sont un excellent moyen de maintenir les liens sociaux au sein d’une équipe. Ils représentent à plus d’un titre de nombreux avantages en termes de développement de la confiance (en soi et dans les autres), d’intervention en intelligence de situation, de mise en situations et rapport à l’erreur, de concentration et de focalisation sur l’action immédiate à venir.")
        },
        {
            tag: {
                id: "1",
                "title": this.translate.instant("General")
            },
            createdDate: this.translate.instant("February, 8 2021"),
            title: this.translate.instant("Analyse critique des modèles d’apprentissage"),
            link: "FR_Analyse_Critique_Modeles_Apprentissage.pdf",
            linkEN: "EN_Critical_Analysis_Learning_Models.pdf",
            img: "assets/Livre_Blanc_Julian",
            shortDesc: this.translate.instant("La pyramide d’Edgar Dale est souvent associée à des pourcentages par des organismes de formation pour promouvoir les pédagogies actives. Néanmoins ce modèle est d’origine marketing et ne repose sur aucun fondement scientifique. Il convient donc de se tourner vers d’autres modèles comme ceux d’Agyris, de Schön ou encore de  Kolb  (1984)  mettant  en  avant  l’importance  du  faire  dans  les  apprentissages.  En  parallèle,  en  étudiant  ces  différents  modèles,  nous pouvons recenser à quel point le jeu et par extension le jeu sérieux  s’inscrivent  en  totale  cohérence  avec  de  tels  modèles  d’apprentissage.")
        },
        {
            tag: {
                id: "9",
                "title": this.translate.instant("Clients")
            },
            createdDate: this.translate.instant("December, 14 2020"),
            title: this.translate.instant("EGIS testimonial"),
            link: "Egis_Testimonial.pdf",
            img: "assets/Livre_Blanc_Egis",
            shortDesc: this.translate.instant("In collaboration, IMMERSIVE FACTORY designed, developed and helped EGIS to implement the VR based «Motorway Operations» training program for their patrollers. This course raises awareness among EGIS teams about risks and validates compliance with procedures by putting them in situation on how to make decisions on actions to take in case of a fast track accident. The program was so successful that in September 2019, EGIS also used virtual reality training programs for their experienced patrollers to keep their knowledge up-to-date and to renew their traffic certification. This certification and continuous training is now part of their culture.")
        }
    ];



    constructor(
        protected _sanitizer: DomSanitizer,
        public newsService: NewsService,
        protected activatedRoute: ActivatedRoute,
        public language: LanguageService,
        public contactService:ContactService,
        public translate : TranslateService,
        public utilsService:UtilsService
    ) {
        this.langSub = this.language.langChange.subscribe(data => {
            this.refreshActus(true);
        })
    }

    ngOnInit() {
        this.getCurrentLang()
        var allCountriesOBJ = getNames(this.translate.store.currentLang)
        this.allCountries = []
        for(let ctr of Object.keys(allCountriesOBJ)){
            this.allCountries.push({code : ctr.toLowerCase(), name : allCountriesOBJ[ctr]})
        }
        this.slides = this.featuredWhitePaper[this.featuredWhitePaperId].slides;
        this.refreshActus();
        this.refreshTags();
        this.problem = {
            where:false,
            mail:false,
            name:false,
            tel:false,
            country:false,
            company:false,
            interest: false,
            message:false
        }
        this.where = "Page whitepaper";
        this.name = "";
        this.mail = "";
        this.tel = "";
        this.country = null;
        this.interest = "whitepaper";
        this.company = "";
        this.message = "";
    }



    ngOnDestroy() {
        this.langSub.unsubscribe();
    }

    refreshTags() {
        this.newsService.getTags(true)
        .then(res => {
            this.tags = res.filter(tag => tag.title != 'R&D');
        });
    }

    refreshActus(reset = false) {
        return Promise.resolve()
        .then(() => {
            if (!this.activeTag) {
                return this.getPapers(this.limit);
            }
            else {
                return this.getPapersByTag(this.activeTag, this.limit);
            }
        })
        .then((res) => {
            if (reset) { this.listWhitePapers = [] }
            this.nbPosts = this.posts.length;
            if (res) {
                for (let post of res) {
                    this.listWhitePapers.push(post);
                }
            }
        })
    }

    getCurrentLang(){
        this.currentLang = this.translate.store.currentLang;
    }

    selectTag(tagId) {
        this.activeTag = tagId;
        console.log(this.activeTag)
        this.limit = this.itemsPerPage;
        this.refreshActus(true)
    }

    showMoreActu() {
        this.limit = this.limit + this.itemsPerPage;
        this.refreshActus();
    }


    getPapers(limit = 10) {
        this.tagLimit = false;
        var whitePapers = [];
        var diff = 0;
        if (this.posts.length <= this.limit) {
            diff = this.limit - this.itemsPerPage;
            whitePapers = this.posts.slice(diff, this.posts.length);
        }
        else {
            whitePapers = this.posts.slice(0, limit);
        }
        return whitePapers;
    }

    getPapersByTag(activeTag, limit = 10) {
        var whitePapers = [];
        var i = 0;
        for (let news of this.posts) {
            if (news.tag.id == activeTag) {
                i++;
                whitePapers.push(news);
            }
        }
        if (i <= this.limit) {
            this.tagLimit = true;
        }
        else {
            this.tagLimit = false;
        }
        return whitePapers;
    }

    showModalContact(office=null){
        this.toContact = null
        if(office){
            this.toContact = office
        }
        if(isBrowser()) $('#contact-modal').modal('show')
    }

    hideModalContact(){
        this.whitePaperUrl = null;
        if(isBrowser()) $('#contact-modal').modal('hide')
    }

    sendForm(){
        this.sendDisabled = true;
        if(isBrowser()) $("#validButton").text(this.translate.instant('Envoi...'));
        this.iframeShow = true;

        var officeId = null
        if(this.toContact && this.toContact.id){
            officeId = this.toContact.id
        }

        var obj = {
            where:this.where,
            name:this.name,
            mail:this.mail,
            tel:this.tel,
            country:this.country,
            company:this.company,
            message:this.message,
            interest:this.interest,
            captcha:grecaptcha.getResponse(),
            officeId : officeId
        }

        var gotProblem = false;
        if(!this.mail.length || !this.utilsService.validMail(this.mail)){
            this.problem.mail = true;
            gotProblem = true;
        }

        if(!this.tel || !this.tel.length){
            this.problem.tel = true;
            gotProblem = true;
        }

        if(!this.name.length){
            this.problem.name = true;
            gotProblem = true;
        }
        if(!this.message.length){
            this.problem.message = true;
            gotProblem = true;
        }

        if(!this.country){
            this.problem.country = true;
            gotProblem = true;
        }

        if(!this.interest){
            this.problem.interest = true;
            gotProblem = true;
        }

        if(!this.company.length){
            this.problem.company = true;
            gotProblem = true;
        }

        if(gotProblem){
            //show modal
            this.modalMessage = this.MISSING_PARAMETER_MESSAGE;
            Swal.fire({
                'text' : this.modalMessage,
                'icon' : "error",
                'showCancelButton': false,
            });
            grecaptcha.reset();

            this.sendDisabled = false
            if(isBrowser()) $("#validButton").text(this.translate.instant('Envoyer'));
        }else{
            this.contactService.postContactForm(obj)
            .then((res)=>{
                grecaptcha.reset();
                if(isBrowser()) $("#validButton").text(this.translate.instant('Envoyer'));
                if(res && res['status'] && res['status'] == 'success'){
                    this.showGratitude = true
                    this.modalMessage = this.translate.instant("Votre message a été envoyé. Nous y répondrons dans les plus brefs délais.");
                    Swal.fire({
                        'text' : this.modalMessage,
                        'icon' : "success",
                        'showCancelButton': false,
                    })
                    .then(()=>{
                        if(isBrowser()) $('#contact-modal').modal('hide')
                        if(isBrowser()) window.open('https://communication.immersivefactory.com/'+this.whitePaperUrl, '_blank').focus();
                        this.problem = {
                            where:false,
                            mail:false,
                            name:false,
                            tel:false,
                            country:false,
                            interest: false,
                            company:false,
                            message:false
                        }
                        this.where = "Page whitepaper";
                        this.name = "";
                        this.mail = "";
                        this.tel = "";
                        this.country = null;
                        this.interest = "whitepaper";
                        this.company = "";
                        this.message = "";
                        this.whitePaperUrl = null
                    })

                }
                else if(res && res['status'] && res['status'] == 'error' && res['message'] && res['message'] == 'bad_captcha'){
                    this.modalMessage = this.translate.instant("Veuillez re-valider le captcha");
                    Swal.fire({
                        'text' : this.modalMessage,
                        'icon' : "error",
                        'showCancelButton': false,
                    });
                    grecaptcha.reset();
                }
                else{
                    this.modalMessage = this.translate.instant("Une erreur est survenue, veuillez réessayer plus tard");
                    Swal.fire({
                        'text' : this.modalMessage,
                        'icon' : "error",
                        'showCancelButton': false,
                    });
                    grecaptcha.reset();
                }
            })
        }
    }

    iframeLoaded(){
        this.showGratitude = false;
    }

    clickOnDownload(actu){
        if(this.currentLang=="en" && actu.linkEN){
          if(isBrowser()) window.open('https://communication.immersivefactory.com/'+actu.linkEN, '_blank').focus();
          // this.whitePaperUrl=actu.link;
          // this.showModalContact()
        }
        else {
          if(isBrowser()) window.open('https://communication.immersivefactory.com/'+actu.link, '_blank').focus();
          // this.whitePaperUrl=actu.link;
          // this.showModalContact()
        }
    }

}
